import React from 'react';
import { Col, Row } from 'react-bootstrap';
import OperacoesCard from '@/containers/Operacoes/Listagem/components/OperacoesCard';

const OperacoesTab = ({
  clienteId
}) => {
  return <Row>
      <Col md={12}>
        <OperacoesCard clienteId={clienteId} showActions={false} enableRowClick={true} showFilter={false} showHeader={false} />
      </Col>
    </Row>;
};

export default OperacoesTab;
